/**
 * src/lib/venue-role.ts — 2304vc
 * Two roles, two views. Simple.
 */

export type VenueRole = 'picker' | 'manager'

export interface RoleConfig {
  label:      string
  sub:        string
  tabs:       TabKey[]
  defaultTab: string
}

export type TabKey = 'pick' | 'shortlist' | 'inflow' | 'library'

export const ROLE_CONFIGS: Record<VenueRole, RoleConfig> = {
  picker: {
    label:      'Picker',
    sub:        'Swipe through photos, build the shortlist',
    tabs:       ['inflow', 'pick'],
    defaultTab: 'inflow',
  },
  manager: {
    label:      'Marketing',
    sub:        'Review the shortlist, select for posting',
    tabs:       ['shortlist', 'library'],
    defaultTab: 'shortlist',
  },
}

export function getStoredRole(venueSlug: string): VenueRole | null {
  try { return localStorage.getItem(`venue_role_${venueSlug}`) as VenueRole | null }
  catch { return null }
}

export function setStoredRole(venueSlug: string, role: VenueRole) {
  try { localStorage.setItem(`venue_role_${venueSlug}`, role) }
  catch {}
}

export function clearStoredRole(venueSlug: string) {
  try { localStorage.removeItem(`venue_role_${venueSlug}`) }
  catch {}
}
